// @flow

import { pincodeServiceActions } from './pincodeActionCreator';

const initialState = {
  checking: null,
  pincodeIndex: null,
  pincodeData: null,
  checked: null,
  error: null,
  eddFetching: null,
  eddFetched: null,
  edd: null,
  checkingInternal: null,
  pincodeDataInternal: null,
  checkedInternal: null,
  errorInternal: null,
  fetchingFromToPairDetails: null,
  fromToPairDetails: null,
  fetchedFromToPairDetails: null,
  errorFromToPair: null,
  downloading: null,
  downloaded: null,
  downloadData: null,
  downloadError: null,
  clientList: []
};

const pincodeReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case pincodeServiceActions.CHECK_PINCODE_SERVICEABILITY: {
      return Object.assign({}, state, action.payload);
    }
    case pincodeServiceActions.GET_LOCALITIES: {
      const pincodeDataCpy = state.pincodeData;
      if (pincodeDataCpy) {
        pincodeDataCpy.localities = action.payload.fetchedLocalities;
      }
      return Object.assign({}, state, action.payload);
    }
    case pincodeServiceActions.GET_EDD: {
      return Object.assign({}, state, action.payload);
    }
    case pincodeServiceActions.CHECK_PINCODE_SERVICEABILITY_INTERNAL: {
      return Object.assign({}, state, action.payload);
    }
    case pincodeServiceActions.GET_FROM_TO_PAIR_DETAILS: {
      return Object.assign({}, state, action.payload);
    }
    case pincodeServiceActions.DOWNLOAD: {
      return Object.assign({}, state, action.payload);
    }
    case pincodeServiceActions.GET_CLIENT: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default pincodeReducer;
